import { VColorPicker } from 'vuetify/lib/components/VColorPicker';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VColorPicker,{attrs:{"dot-size":"25","swatches":_vm.swatches,"show-swatches":"","swatches-max-height":"200"},model:{value:(_vm.item[_vm.changeKey]),callback:function ($$v) {_vm.$set(_vm.item, _vm.changeKey, $$v)},expression:"item[changeKey]"}}),_vm._v(" COLOR: "+_vm._s(_vm.item.color)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }